import axios from 'axios';
import constants from '../constants';
import util from '../util';

const OO_BASE_PATH_LOCAL = "http://localhost:8085/oo/api/v1/public";
const OO_BASE_PATH_TEST = "https://test.mhmfun.com/oo/api/v1/public";
const OO_BASE_PATH_STAGE = "https://www.musthavemenus.com/oostage/api/v1/public";
const OO_BASE_PATH_PROD = "https://www.musthavemenus.com/oo/api/v1/public";
const ONLINE_MENUS_PATH = "/menus";
const ONLINE_MENUS_BUSINESS_PATH = "/business";
const BUSINESS_PATH = "/businesses";
// const ONLINE_MENUS_PATH = "http://localhost:8080/oo/api/v1/public/menus";
// const ONLINE_MENUS_BUSINESS_PATH = "http://localhost:8080/oo/api/v1/public/business";

export const ops = () => {
  const user = "oo-service";
  const pwd = "th3OOs3rv1c31s@m@z1n!-2!";
  return btoa(user + ":" + pwd)
};

const getUrl = (path) => {
  if(util.isLocalhost()){
    return`${OO_BASE_PATH_LOCAL}${path}`;
  }
  if(constants.isTestEnv){
    return`${OO_BASE_PATH_TEST}${path}`;
  }
  if(constants.isStageEnv) {
    return `${OO_BASE_PATH_STAGE}${path}`;
  }
  return `${OO_BASE_PATH_PROD}${path}`;
}

const getMenus = (memberId, businessId) => {
  const url = getUrl(ONLINE_MENUS_PATH);
  return axios.get(url, {params: {memberId, businessId}})
};

const getBusiness = (memberId, businessId) => {
  const url = getUrl(ONLINE_MENUS_BUSINESS_PATH);
  return axios.get(url, {params: {memberId, businessId}})
};

const getStatusForBusiness = (businessId) => {
  const url = getUrl(BUSINESS_PATH);
  return axios.get(`${url}/${businessId}/status`, {
    headers: {
      'token': ops()
    }
  });
};

const getStatusForMember = (memberId) => {
  const url = getUrl(BUSINESS_PATH);
  return axios.get(`${url}/statusById`, {
      params: { memberId },
      headers: {
          'token': ops()
      }
  });
};

export default {
  getMenus,
  getBusiness,
  getStatusForBusiness,
  getStatusForMember
}
